'use client'

import { useEffect, useRef } from 'react'

import { toast } from '@/core/lib/toast'

/** 오류 문구를 화면에 박지 않고 토스트로 띄운다. 같은 문구는 다시 마운트되거나 비워졌다 다시 생길 때만 또 뜬다. */
export default function ErrorToast({ message }: { message?: string | null }) {
  const shown = useRef<string | null>(null)
  useEffect(() => {
    if (!message) {
      shown.current = null
      return
    }
    if (shown.current === message) return
    shown.current = message
    toast.error(message, { duration: 5000 })
  }, [message])
  return null
}
